// Mock catalog. Swap with a real supplier feed later.

// Stable Unsplash photo IDs reused across rooms (prototype assets).
const u = (id) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=900&q=70`;

const P = {
  room1: u('1566073771259-6a8506099945'),
  room2: u('1611892440504-42a792e24d32'),
  room3: u('1582719508461-905c673771fd'),
  room4: u('1631049307264-da0ec9d70304'),
  room5: u('1584132967334-10e028bd69f7'),
  room6: u('1551882547-ff40c63fe5fa'),
  suite: u('1542314831-068cd1dbfeeb'),
  lobby: u('1455587734955-081b22074882'),
  pool: u('1578683010236-d716f9a3f461'),
  resort: u('1564501049412-61c2a3083791'),
  boutique: u('1520250497591-112f2f40a3f4'),
  silk: u('1571896349842-33c89424de2d'),
};

export const CENTERS = {
  Tashkent: [41.311, 69.279],
  Samarkand: [39.655, 66.975],
  Bukhara: [39.775, 64.42],
  Khiva: [41.378, 60.361],
  Fergana: [40.385, 71.786],
  Nukus: [42.46, 59.61],
};

export const CITYMETA = {
  Tashkent: 'Capital · UTC+5',
  Samarkand: 'Registan · Silk Road',
  Bukhara: 'Old town · Lyabi-Hauz',
  Khiva: 'Ichan Qala · walled city',
  Fergana: 'Valley · east',
  Nukus: 'Karakalpakstan · west',
};

const A_BASE = ['Wi-Fi', 'A/C', 'Coffee', 'Towels'];
const A_PLUS = ['Pool', 'Spa', 'Breakfast', 'Parking', 'Gym', 'Bar', 'Workspace'];

export const HOTELS = [
  {
    nm: 'Registon Plaza', city: 'Tashkent', area: 'Yunusobod', st: 4,
    dayBase: 165000, rack: 780000, win: '10:00–22:00', left: 5,
    ll: [41.338, 69.285],
    pics: [P.room2, P.suite, P.lobby, P.room5],
    desc: 'Tower hotel near the business district. Day-use rooms refreshed between blocks, fast check-in at the front desk.',
    amen: [...A_BASE, 'Gym', 'Workspace', 'Bar'],
  },
  {
    nm: 'Amir Court Boutique', city: 'Tashkent', area: 'Mirabad', st: 3,
    dayBase: 120000, rack: 520000, win: '09:00–20:00', left: 2,
    ll: [41.299, 69.276],
    pics: [P.boutique, P.room1, P.room6, P.room4],
    desc: 'Quiet courtyard hotel a short walk from Mirabad market. Compact rooms, friendly host, strong tea on arrival.',
    amen: [...A_BASE, 'Breakfast', 'Workspace'],
  },
  {
    nm: 'Silk Road Grand', city: 'Tashkent', area: 'City centre', st: 5,
    dayBase: 240000, rack: 1180000, win: '11:00–23:00', left: 6,
    ll: [41.318, 69.252],
    pics: [P.suite, P.pool, P.room5, P.lobby],
    desc: 'Five-star flagship in the city centre. Pool, spa, late check-out included on day-use blocks of 6h or more.',
    amen: [...A_BASE, 'Pool', 'Spa', 'Gym', 'Bar', 'Breakfast'],
  },
  {
    nm: 'Afrosiyob Palace', city: 'Samarkand', area: 'Registan', st: 4,
    dayBase: 155000, rack: 690000, win: '10:00–21:00', left: 3,
    ll: [39.6547, 66.9758],
    pics: [P.silk, P.room3, P.lobby, P.room2],
    desc: '7 minutes on foot from the Registan. Tile-clad façade, cool inner courtyard, perfect for a midday reset.',
    amen: [...A_BASE, 'Breakfast', 'Parking'],
  },
  {
    nm: 'Bibikhonym Residence', city: 'Samarkand', area: 'Old town', st: 3,
    dayBase: 110000, rack: 430000, win: '10:00–20:00', left: 1,
    ll: [39.6606, 66.981],
    pics: [P.room1, P.boutique, P.silk, P.room6],
    desc: 'Family-run residence in a converted madrasa-style building. Eight rooms only, hot showers, tea always on.',
    amen: [...A_BASE, 'Breakfast'],
  },
  {
    nm: 'Lyabi Court House', city: 'Bukhara', area: 'Lyabi-Hauz', st: 3,
    dayBase: 115000, rack: 460000, win: '09:00–21:00', left: 4,
    ll: [39.7745, 64.4205],
    pics: [P.silk, P.room4, P.lobby, P.room1],
    desc: 'Traditional courtyard house steps from Lyabi-Hauz pond. Carved doors, mulberry shade, calm hours after lunch.',
    amen: [...A_BASE, 'Breakfast', 'Parking'],
  },
  {
    nm: 'Minora Caravan Inn', city: 'Bukhara', area: 'Kalon', st: 4,
    dayBase: 150000, rack: 610000, win: '10:00–22:00', left: 2,
    ll: [39.7758, 64.4145],
    pics: [P.lobby, P.silk, P.room2, P.suite],
    desc: 'Boutique inn beside the Kalon minaret. Roof terrace at sunset, hammam access during overnight stays.',
    amen: [...A_BASE, 'Spa', 'Breakfast', 'Bar'],
  },
  {
    nm: 'Ichan Gate Boutique', city: 'Khiva', area: 'Ichan Qala', st: 3,
    dayBase: 105000, rack: 410000, win: '10:00–20:00', left: 3,
    ll: [41.3782, 60.3617],
    pics: [P.silk, P.boutique, P.room6, P.room1],
    desc: 'Inside the walled old town, two minutes from the west gate. Small, clean rooms, courtyard breakfast.',
    amen: [...A_BASE, 'Breakfast'],
  },
  {
    nm: 'Orient Star Khiva', city: 'Khiva', area: 'West gate', st: 4,
    dayBase: 135000, rack: 560000, win: '11:00–21:00', left: 2,
    ll: [41.3789, 60.3585],
    pics: [P.lobby, P.suite, P.silk, P.room5],
    desc: 'Converted madrasa cells, each with its own tiny vaulted ceiling. Quiet, cool, theatrical at night.',
    amen: [...A_BASE, 'Breakfast', 'Bar'],
  },
  {
    nm: 'Fergana Grand', city: 'Fergana', area: 'Mustaqillik', st: 4,
    dayBase: 125000, rack: 480000, win: '09:00–22:00', left: 5,
    ll: [40.3842, 71.787],
    pics: [P.resort, P.pool, P.room2, P.lobby],
    desc: 'Anchor business hotel in the valley. Reliable Wi-Fi, big desks, secure parking. A solid day-use base.',
    amen: [...A_BASE, 'Pool', 'Gym', 'Workspace', 'Parking'],
  },
  {
    nm: 'Jipek Joli Inn', city: 'Nukus', area: 'Dosnazarov', st: 3,
    dayBase: 95000, rack: 360000, win: '10:00–20:00', left: 4,
    ll: [42.4565, 59.61],
    pics: [P.boutique, P.room3, P.room4, P.suite],
    desc: 'The classic Nukus traveller inn. Karakalpak food downstairs, tour desk for Aral Sea trips.',
    amen: [...A_BASE, 'Breakfast', 'Bar'],
  },
];

// Per-hotel discount % for "Tonight" overnight deals.
export const NIGHT_OFFS = [40, 45, 35, 50, 30, 45, 38, 42, 48, 33, 40];

// Number-of-hours multiplier for day-use blocks.
export const DAY_MULT = { 3: 1, 6: 1.75, 9: 2.4 };
